var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankYuanta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50446 11.7365C7.50349 11.7053 7.50879 11.6743 7.52005 11.6452C7.53131 11.6161 7.5483 11.5895 7.57001 11.5671C7.59172 11.5447 7.6177 11.5269 7.64643 11.5147C7.67515 11.5025 7.70603 11.4962 7.73723 11.4962L12.1545 11.4688C12.286 11.4661 12.3914 11.571 12.3914 11.7046C12.3949 11.7334 12.3882 11.7654 12.3751 11.7947L10.2014 17.2007C10.1667 17.2834 10.0836 17.3465 9.98485 17.3465C9.92009 17.3465 9.86148 17.3177 9.81821 17.2799C9.81821 17.2763 9.81158 17.2744 9.81158 17.2699C8.44267 15.8187 7.57693 13.8841 7.5 11.7469C7.5 11.7428 7.50446 11.7393 7.50446 11.7393V11.7365Z",
    fill: "url(#paint0_linear_10834_56995)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.18 18.7829L14.8003 12.268C14.8034 12.2653 14.8034 12.2617 14.8067 12.258C14.989 11.7827 15.4563 11.4396 15.9994 11.4375C16.5105 11.4339 16.9516 11.7278 17.1649 12.1573L19.9207 18.7317V18.7343C19.9315 18.7613 19.9383 18.792 19.9383 18.8243C19.9383 18.9108 19.8929 18.9882 19.8221 19.0286C19.8186 19.0331 19.8163 19.0331 19.8122 19.0349C18.685 19.6048 17.4049 19.9261 16.0566 19.9405C14.7049 19.9495 13.4286 19.6425 12.2907 19.0871H12.2881C12.2499 19.0671 12.2178 19.0371 12.1953 19.0003C12.1728 18.9636 12.1607 18.9214 12.1602 18.8783C12.1594 18.8479 12.1644 18.8177 12.175 18.7892C12.1751 18.7893 12.18 18.7866 12.18 18.7829Z",
    fill: "url(#paint1_linear_10834_56995)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6248 11.7473V11.7397C19.6122 11.7114 19.6085 11.683 19.6055 11.6547C19.6055 11.5233 19.7112 11.4143 19.8418 11.4143L24.2605 11.3828C24.3226 11.3828 24.3823 11.4073 24.4264 11.451C24.4705 11.4948 24.4954 11.5542 24.4959 11.6164C24.4991 11.619 24.4991 11.6223 24.4991 11.6223C24.4555 13.763 23.6177 15.7139 22.2691 17.1866C22.2655 17.1866 22.2655 17.1902 22.2655 17.1902C22.22 17.2316 22.1606 17.2641 22.0936 17.2641C22.0469 17.264 22.0013 17.2501 21.9625 17.2241C21.9237 17.1982 21.8935 17.1613 21.8757 17.1181L19.6248 11.7473Z",
    fill: "url(#paint2_linear_10834_56995)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8053 8.95169L18.6319 8.98763H18.6112C18.5681 8.9843 18.5268 8.96902 18.4918 8.94351C18.4569 8.91799 18.4298 8.88325 18.4136 8.84318L17.998 7.8489C17.4287 6.3792 17.1562 4.97534 17.1603 3.68801L17.1562 3.2915C17.1562 3.16052 17.2593 3.05469 17.3904 3.05469H17.4219C17.425 3.05687 17.4314 3.05687 17.4314 3.05687C20.508 3.57891 23.0235 5.75222 24.0269 8.63924L24.03 8.6424C24.0399 8.66399 24.0422 8.69002 24.0422 8.71616C24.0423 8.74723 24.0362 8.77802 24.0244 8.80673C24.0125 8.83545 23.995 8.86152 23.973 8.88343C23.951 8.90534 23.9248 8.92266 23.896 8.93437C23.8672 8.94609 23.8364 8.95198 23.8053 8.95169Z",
    fill: "url(#paint3_linear_10834_56995)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9491 7.87531L13.5494 8.87554C13.5184 8.94662 13.4541 9.00385 13.3779 9.01949H13.3564C13.3456 9.02355 13.3361 9.02355 13.3361 9.02355L8.15763 9.06137C8.09404 9.06185 8.03283 9.03727 7.98724 8.99294C7.94165 8.94862 7.91536 8.88812 7.91406 8.82455C7.91406 8.79931 7.9208 8.77357 7.92763 8.75218V8.74812C8.89178 5.85249 11.3793 3.63651 14.4488 3.07427H14.4555C14.4681 3.07031 14.4799 3.07031 14.4866 3.07031C14.6166 3.07031 14.7264 3.17337 14.7264 3.30475L14.7301 3.70353H14.7264C14.7491 4.99235 14.4975 6.39898 13.9491 7.87531Z",
    fill: "url(#paint4_linear_10834_56995)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10834_56995",
    x1: 9.88659,
    y1: 3.10991,
    x2: 10.0017,
    y2: 19.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10834_56995",
    x1: 15.9404,
    y1: 3.06299,
    x2: 16.0555,
    y2: 19.7533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10834_56995",
    x1: 21.9928,
    y1: 3.02595,
    x2: 22.1079,
    y2: 19.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10834_56995",
    x1: 20.5787,
    y1: 3.0327,
    x2: 20.6938,
    y2: 19.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10834_56995",
    x1: 11.3002,
    y1: 3.09228,
    x2: 11.4153,
    y2: 19.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankYuanta);
export default __webpack_public_path__ + "static/media/BankYuanta.41e8c2a2ff4e0c1ef483c893ab336739.svg";
export { ForwardRef as ReactComponent };